import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { GovernyInfo, NewsData } from "../../../../lib/types";
import { NEWS_DETAIL } from "../../../../lib/enums";
import DetailGenerals from "./DetailGenerals";
import DetailBuildingDamage from "./DetailBuildingDamage";
import DetailStolenResources from "./DetailStolenResources";
import GovernorateInfoLink from "../../../Common/GovernorateInfoLink";

interface IProps {
  sender: GovernyInfo;
  target: GovernyInfo;
  action: NewsData;
  opponent?: boolean;
}

const mapStateToProps = (state: any) => ({
  unitNames: state.governorate.unitNames
})

const connector = connect(mapStateToProps);

const NewsPersonThievesAction = ({
  sender,
  target,
  action,
  opponent,
  unitNames
}: IProps & ConnectedProps<typeof connector>) => (
<div className="text-item" style={{ borderBottom: "1px solid #242424", borderTop: "none" }}>
  <GovernorateInfoLink govId={sender.id} name={sender.name} raceName={sender.race.name} />&nbsp;
  <i className={`icon icon-zlodeji ${action.success ? "positive" : "negative"} middle`}/>
  &nbsp;<GovernorateInfoLink govId={target.id} name={target.name} raceName={target.race.name} />
  <div><strong className="white">{action.thiefAction.name}</strong></div>

  <div id="news-detail-{{ action.id }}" style={{ paddingTop: "7px", paddingBottom: "7px" }}>
    {action.success
      ? <>{action.actionConstantEffectDescription || action.effectDescription
        ? <div>
          {action.effectDescription || action.actionConstantEffectDescription}
        </div>
        : action.thiefAction.id === 1
          ? <div>Influence: <em>+{action.influenceGain}</em></div>
          : action.thiefAction.id === 2
            ? action.details[NEWS_DETAIL.EspionageTurns]
              ? <>
                <div>Turns <em>{action.details[NEWS_DETAIL.EspionageTurns].value}</em></div><br />
                <div>Civil pops<br/>
                  Farmers <em>{action.details[NEWS_DETAIL.EspionageFarmers].value}</em>
                  <br/>Stone miners <em>
                    {action.details[NEWS_DETAIL.EspionageStoneMiners].value}</em>
                  <br/>Iron miners <em>
                    {action.details[NEWS_DETAIL.EspionageIronMiners].value}</em>
                  <br/>Druids <em>{action.details[NEWS_DETAIL.EspionageDruids].value}</em>
                  <br/>Bakers <em>{action.details[NEWS_DETAIL.EspionageBakers].value}</em>
                  <br/>Masons <em>{action.details[NEWS_DETAIL.EspionageMasons].value}</em>
                  <br/>Smiths <em>{action.details[NEWS_DETAIL.EspionageSmiths].value}</em>
                  <br/>Traders <em>{action.details[NEWS_DETAIL.EspionageTraders].value}</em>
                  <br/>Alchemists <em>{action.details[NEWS_DETAIL.EspionageAlchemists].value}</em>
                  <br/>Serfs: <em>{action.details[NEWS_DETAIL.EspionageSerfs].value}</em>
                </div><br />
                <div>Army<br/>
                {unitNames[target.race.id].e1} <em>
                  {action.details[NEWS_DETAIL.EspionageE1].value}</em>
                  <br/> {unitNames[target.race.id].e2} <em>
                    {action.details[NEWS_DETAIL.EspionageE2].value}</em>
                  <br/> {unitNames[target.race.id].e3} <em>
                    {action.details[NEWS_DETAIL.EspionageE3].value}</em>
                  <br/>Siege engines <em>{action.details[NEWS_DETAIL.EspionageSieges].value}</em>
                  <br/> Dragons <em>{action.details[NEWS_DETAIL.EspionageDragons].value}</em>
                </div>
                <br />
                <div>Generals:
                  <div>
                    <DetailGenerals
                      generalsString={action.details[NEWS_DETAIL.EspionageGenerals].value}
                    />
                  </div>
                </div>
                {action.details[NEWS_DETAIL.EspionageWeakness]
                && <>
                  <br />
                  <div>
                    Shadow:<br />
                    Generals -{action.details[NEWS_DETAIL.EspionageWeakness].value}&nbsp;
                    Attack next count
                  </div>
                </>}
              </> : <div>No effect</div>
            : <>
              {action.details[NEWS_DETAIL.CivilLoses] && <div>
                Civilians killed: <em>{action.details[NEWS_DETAIL.CivilLoses].value}</em>
              </div>}

              {action.armyLoses
              && <div>
                Army units killed:<br/>
                {unitNames[target.race.id].e1}: <em>
                {action.details[NEWS_DETAIL.DefenceE1Loses].value}</em>
                <br/> {unitNames[target.race.id].e2}: <em>
                {action.details[NEWS_DETAIL.DefenceE2Loses].value}</em>
                <br/> {unitNames[target.race.id].e3}: <em>
                {action.details[NEWS_DETAIL.DefenceE3Loses].value}</em>
              </div>}

              {action.buildingDamage && <div>
                Building damage:{<DetailBuildingDamage
                buildingDamage={action.details[NEWS_DETAIL.BuildingDamage].value}/>}
              </div>}

              {action.stolenResources && <div>
                Stolen resources: <br/>{<DetailStolenResources
                stolenResources={action.details[NEWS_DETAIL.StolenResources].value}/>}
              </div>}
            </>}
        {action.thiefAction.id !== 1 && !!action.influenceGain
        && <div>Influence: <em>+{action.influenceGain}</em></div>}
      </>
      : null
    }
  </div>
  {action.thiefAction.id !== 8 ? <div style={{ display: "flex", justifyContent: "space-evenly" }}>
    <span>{opponent ? "Attack" : "Defence"} {action.details[NEWS_DETAIL.ActionPower].value}</span>
    {action.details[NEWS_DETAIL.GeneralExpGain]
    && <span>XP +{action.details[NEWS_DETAIL.GeneralExpGain].value}</span>}
  </div> : null}
</div>
)

export default connector(NewsPersonThievesAction);
